import { render } from "./AppDetails.vue?vue&type=template&id=6c4e4113&scoped=true"
import script from "./AppDetails.vue?vue&type=script&lang=js"
export * from "./AppDetails.vue?vue&type=script&lang=js"

import "./AppDetails.vue?vue&type=style&index=0&id=6c4e4113&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4e4113"]])

export default __exports__